import * as React from 'react';
import { brandSchema, marketSchema } from 'data/schema';
import { userSession } from 'state/session';
import { user } from 'utils/auth/user';
import { initUserlane, openUserlane } from 'utils/ui/userlane';
import { getLocale } from 'i18n/locale';

const UserlaneButton: React.FC = () => {
  const session = userSession().useState();
  const brand = brandSchema.parse(session?.brand || user.brand);
  const market = marketSchema.parse(session?.market || user.market.iso3);
  const locale = session?.locale || getLocale(market);

  React.useEffect(() => {
    initUserlane(locale, market, brand);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (brand !== 'A') {
    return null;
  }

  return (
    <div
      className="flex size-8 cursor-pointer items-center justify-center rounded-full bg-white"
      role="button"
      tabIndex={-1}
      onClick={openUserlane}
    >
      <p className="text-teal-700">?</p>
    </div>
  );
};

export default UserlaneButton;
